var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApcIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.924 13.33l-1.372-2.447h4.96L8.022 5.61 4.37 13.33H0L5.72 2.91h4.602L16 13.33H6.924z",
    fill: "#ED005B"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjkyMzYzIDEzLjMzMDFMNS41NTE2NiAxMC44ODMzSDEwLjUxMjFMOC4wMjE1NiA1LjYwOThMNC4zNjk4NiAxMy4zMzAxSDBMNS43MjA1NyAyLjkxMDE2SDEwLjMyMkwxNiAxMy4zMzAxSDYuOTIzNjNaIiBmaWxsPSIjRUQwMDVCIi8+Cjwvc3ZnPgo=";
export { SvgApcIcon as ReactComponent };